export default "__VITE_ASSET__5Lnkv0I0__"